<template>
  <div class="data-backtest">
    <div class="toolbar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        size="small"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始"
        end-placeholder="结束"
        :picker-options="pickerOptions"
      />
      <el-button type="primary" size="small" :loading="loading" @click="handleQuery">查询</el-button>
      <el-button size="small" @click="openRecordLibrary">记录库</el-button>
      <el-button size="small" :disabled="!rows.length" @click="probDialogVisible = true">概率统计</el-button>
      <el-select
        v-model="filterBao"
        size="small"
        multiple
        collapse-tags
        placeholder="爆量"
        style="width: 180px"
        @change="onFilterBaoChange"
      >
        <el-option label="全部" value="all" />
        <el-option label="缩量" value="shrink" />
        <el-option label="爆2" value="bao2" />
        <el-option label="爆3" value="bao3" />
      </el-select>
      <el-popover placement="bottom" width="280" trigger="click">
        <el-checkbox-group v-model="visibleCols" class="col-check-group">
          <el-checkbox v-for="c in allColumns" :key="c.key" :label="c.key">{{ c.label }}</el-checkbox>
        </el-checkbox-group>
        <el-button slot="reference" size="small">显示列</el-button>
      </el-popover>
      <span v-if="rows.length" class="hint">共 {{ filteredRows.length }}{{ filteredRows.length !== rows.length ? ` / ${rows.length}` : '' }} 波</span>
    </div>

    <div class="table-wrap">
      <el-table
        :key="tableColKey"
        v-loading="loading"
        :data="filteredRows"
        border
        size="small"
        height="100%"
        class="result-table"
        empty-text="请选择日期范围后查询"
      >
        <el-table-column label="记录库" width="72" align="center" fixed>
          <template slot-scope="{ row }">
            <el-checkbox
              :value="isInLibrary(row)"
              :disabled="!!row._libBusy"
              @change="(val) => onToggleLibrary(row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="isCol('name')" prop="name" label="股票名称" width="96" fixed show-overflow-tooltip />
        <el-table-column v-if="isCol('code')" prop="code" label="代码" width="88" show-overflow-tooltip />
        <el-table-column v-if="isCol('firstBoardDate')" prop="firstBoardDate" label="首板时间" width="112" />
        <el-table-column v-if="isCol('freeFloatMarketCap')" prop="freeFloatMarketCap" label="自由流通市值(亿)" width="150" sortable :formatter="fmtNum" />
        <el-table-column v-if="isCol('ma250')" prop="ma250" label="MA250" width="110" sortable :formatter="fmtNum" />
        <el-table-column v-if="isCol('finalBoards')" prop="finalBoards" label="最终连板高度" width="120" sortable />
        <el-table-column v-if="isCol('baoVol')" label="爆量" width="96" :formatter="fmtBaoVol" />
        <el-table-column v-if="isCol('shortChip')" prop="shortChip" label="短期筹码分" width="112" sortable :formatter="fmtChipPct" />
        <el-table-column v-if="isCol('midChip')" prop="midChip" label="中期筹码分" width="112" sortable :formatter="fmtChipPct" />
        <el-table-column v-if="isCol('longChip')" prop="longChip" label="长期筹码分" width="112" sortable :formatter="fmtChipPct" />
        <el-table-column v-if="isCol('chipScoreSum')" prop="chipScoreSum" label="筹码总分" width="112" sortable :formatter="fmtChipPct" />
        <el-table-column v-if="isCol('fullChip')" prop="fullChip" label="全周期筹码分" width="120" sortable :formatter="fmtChipPct" />
        <el-table-column v-if="isCol('firstBoardPrice')" prop="firstBoardPrice" label="首板价格" width="96" sortable :formatter="fmtNum" />
        <el-table-column v-if="isCol('yearHighNear1y')" prop="yearHighNear1y" label="近一年最高" width="112" sortable :formatter="fmtNum" />
        <el-table-column v-if="isCol('distToYearHighPct')" prop="distToYearHighPct" label="距年高涨幅" width="112" sortable :formatter="fmtPct" />
        <el-table-column v-if="isCol('chipSlope')" prop="chipSlope" label="筹码分斜率" width="112" sortable :formatter="fmtSlope" />
        <el-table-column v-if="isCol('mainNetInflow')" prop="mainNetInflow" label="资金净流入(亿)" width="128" sortable :formatter="fmtYi" />
        <el-table-column v-if="isCol('netInflowToAmount')" prop="netInflowToAmount" label="净流入/成交额" width="128" sortable :formatter="fmtRatio" />
        <el-table-column v-if="isCol('auctionGain2b')" prop="auctionGain2b" label="2B竞价涨幅" width="116" sortable :formatter="fmtAuctionNum" />
        <el-table-column v-if="isCol('auctionTurnover2b')" prop="auctionTurnover2b" label="2B竞价实际换手" width="140" sortable :formatter="fmtAuctionNum" />
        <el-table-column v-if="isCol('auctionVolumeRatio2b')" prop="auctionVolumeRatio2b" label="2B竞价量比" width="116" sortable :formatter="fmtAuctionNum" />
        <el-table-column v-if="isCol('auctionKillScore2b')" prop="auctionKillScore2b" label="2B竞价绝杀分" width="128" sortable :formatter="fmtAuctionNum" />
      </el-table>
    </div>

    <el-dialog title="概率统计" :visible.sync="probDialogVisible" width="780px" append-to-body>
      <p class="prob-tip">基于当前查询结果；筹码分阈值按「百分数」填写（如 5 表示 5%）。空条件不参与。勾选爆2/爆3时先过滤样本再算概率（同时勾选为「爆2或爆3」）。展开行可看命中个股。</p>
      <el-form label-width="120px" size="mini">
        <el-form-item label="样本过滤">
          <el-checkbox v-model="probRequireBao2">爆2</el-checkbox>
          <el-checkbox v-model="probRequireBao3" style="margin-left: 12px">爆3</el-checkbox>
        </el-form-item>
        <el-form-item v-for="f in probFields" :key="f.key" :label="f.label">
          <el-select v-model="probForm[f.key].op" style="width: 90px; margin-right: 8px">
            <el-option label="≤" value="lte" />
            <el-option label="≥" value="gte" />
            <el-option label="区间" value="range" />
          </el-select>
          <template v-if="probForm[f.key].op === 'range'">
            <el-input v-model="probForm[f.key].min" placeholder="min" style="width: 90px" />
            <span style="margin: 0 6px">~</span>
            <el-input v-model="probForm[f.key].max" placeholder="max" style="width: 90px" />
          </template>
          <el-input v-else v-model="probForm[f.key].value" placeholder="阈值" style="width: 120px" />
          <span v-if="f.asPct" class="unit">%</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="probDialogVisible = false">关闭</el-button>
        <el-button type="primary" size="small" @click="runProbStats">计算</el-button>
      </div>
      <p v-if="probFilterHint" class="prob-tip">{{ probFilterHint }}</p>
      <el-table v-if="probResults.length" :data="probResults" border size="mini" style="margin-top: 12px">
        <el-table-column type="expand">
          <template slot-scope="{ row }">
            <el-table v-if="row.hits && row.hits.length" :data="row.hits" border size="mini" max-height="240">
              <el-table-column prop="name" label="股票名称" min-width="100" />
              <el-table-column label="爆量" width="96" :formatter="fmtBaoVol" />
              <el-table-column prop="finalBoards" label="最终连板高度" width="120" />
            </el-table>
            <div v-else class="prob-tip">无命中</div>
          </template>
        </el-table-column>
        <el-table-column prop="label" label="条件" min-width="160" />
        <el-table-column prop="hit" label="命中" width="70" />
        <el-table-column prop="sample" label="样本" width="70" />
        <el-table-column prop="pct" label="概率" width="90" />
      </el-table>
    </el-dialog>

    <el-dialog
      title="记录库"
      custom-class="data-backtest-record-library-dialog"
      :visible.sync="recordLibraryVisible"
      width="95%"
      top="4vh"
      append-to-body
      @open="onRecordLibraryDialogOpen"
    >
      <el-tabs v-model="recordLibraryTab">
        <el-tab-pane label="龙头库" name="dragon">
          <RecordLibraryTable
            ref="recordLibraryTable"
            :rows="recordLibraryList"
            :loading="recordLibraryLoading"
            editable
            :editing-id="recordLibraryEditingId"
            :initial-score-version="recordLibraryScoreVersion"
            :max-height="520"
            empty-text="暂无记录，可在本页勾选入库，或在历史首板/复盘笔记入库存"
            @score-version-change="onRecordLibraryScoreVersionChange"
            @start-edit="startRecordLibraryEdit"
            @save-edit="saveRecordLibraryEdit"
            @remove="removeRecordLibraryItem"
          />
        </el-tab-pane>
        <el-tab-pane label="补涨库" name="gapup">
          <GapUpRecordLibraryTable
            :rows="gapUpLibraryList"
            :loading="gapUpLibraryLoading"
            :max-height="520"
            @changed="loadGapUpLibrary"
          />
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button @click="recordLibraryVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { stockApi } from '@/api/stockApi'
import RecordLibraryTable from '@/components/RecordLibraryTable.vue'
import GapUpRecordLibraryTable from '@/components/GapUpRecordLibraryTable.vue'

const DEFAULT_VISIBLE = [
  'name',
  'code',
  'firstBoardDate',
  'freeFloatMarketCap',
  'ma250',
  'finalBoards',
  'baoVol',
  'shortChip',
  'midChip',
  'longChip',
  'chipScoreSum',
  'fullChip',
  'firstBoardPrice',
  'yearHighNear1y',
  'distToYearHighPct',
  'chipSlope',
  'mainNetInflow',
  'netInflowToAmount',
  'auctionGain2b',
  'auctionTurnover2b',
  'auctionVolumeRatio2b',
  'auctionKillScore2b'
]

function emptyProbCond(op = 'lte') {
  return { op, value: '', min: '', max: '' }
}

const PROB_DEFAULT_GTE = new Set(['auctionGain2b', 'auctionTurnover2b', 'auctionKillScore2b'])

function hitStockBrief(row) {
  return {
    name: row.name || '-',
    code: row.code || '-',
    bao2: row.bao2,
    bao3: row.bao3,
    finalBoards: row.finalBoards != null ? row.finalBoards : '-'
  }
}

function withChipScoreSum(rows) {
  return (Array.isArray(rows) ? rows : []).map((r) => {
    const s = Number(r.shortChip)
    const m = Number(r.midChip)
    const l = Number(r.longChip)
    const ok = Number.isFinite(s) && Number.isFinite(m) && Number.isFinite(l)
    return {
      ...r,
      chipScoreSum: ok ? s + m + l : null
    }
  })
}

export default {
  name: 'DataBacktest',
  components: { RecordLibraryTable, GapUpRecordLibraryTable },
  data() {
    const probFields = [
      { key: 'shortChip', label: '短期筹码分', asPct: true },
      { key: 'midChip', label: '中期筹码分', asPct: true },
      { key: 'longChip', label: '长期筹码分', asPct: true },
      { key: 'fullChip', label: '全周期筹码分', asPct: true },
      { key: 'chipSlope', label: '筹码分斜率', asPct: false },
      // 竞价字段入库已是百分数口径（与表列一致），阈值按显示值填，不再 /100
      { key: 'auctionGain2b', label: '次日竞价涨幅', asPct: false },
      { key: 'auctionTurnover2b', label: '次日实际换手', asPct: false },
      { key: 'auctionKillScore2b', label: '次日绝杀分', asPct: false }
    ]
    const probForm = {}
    probFields.forEach((f) => {
      probForm[f.key] = emptyProbCond(PROB_DEFAULT_GTE.has(f.key) ? 'gte' : 'lte')
    })
    return {
      dateRange: [],
      loading: false,
      rows: [],
      filterBao: ['all'],
      visibleCols: [...DEFAULT_VISIBLE],
      allColumns: [
        { key: 'name', label: '股票名称' },
        { key: 'code', label: '代码' },
        { key: 'firstBoardDate', label: '首板时间' },
        { key: 'freeFloatMarketCap', label: '自由流通市值(亿)' },
        { key: 'ma250', label: 'MA250' },
        { key: 'finalBoards', label: '最终连板高度' },
        { key: 'baoVol', label: '爆量' },
        { key: 'shortChip', label: '短期筹码分' },
        { key: 'midChip', label: '中期筹码分' },
        { key: 'longChip', label: '长期筹码分' },
        { key: 'chipScoreSum', label: '筹码总分' },
        { key: 'fullChip', label: '全周期筹码分' },
        { key: 'firstBoardPrice', label: '首板价格' },
        { key: 'yearHighNear1y', label: '近一年最高' },
        { key: 'distToYearHighPct', label: '距年高涨幅' },
        { key: 'chipSlope', label: '筹码分斜率' },
        { key: 'mainNetInflow', label: '资金净流入(亿)' },
        { key: 'netInflowToAmount', label: '净流入/成交额' },
        { key: 'auctionGain2b', label: '2B竞价涨幅' },
        { key: 'auctionTurnover2b', label: '2B竞价实际换手' },
        { key: 'auctionVolumeRatio2b', label: '2B竞价量比' },
        { key: 'auctionKillScore2b', label: '2B竞价绝杀分' }
      ],
      pickerOptions: {},
      probDialogVisible: false,
      probFields,
      probForm,
      probRequireBao2: false,
      probRequireBao3: false,
      probFilterHint: '',
      probResults: [],
      libraryKeySet: {},
      recordLibraryVisible: false,
      recordLibraryTab: 'dragon',
      recordLibraryLoading: false,
      recordLibraryList: [],
      recordLibraryEditingId: '',
      recordLibraryScoreVersion: 'V5',
      gapUpLibraryList: [],
      gapUpLibraryLoading: false
    }
  },
  mounted() {
    this.refreshLibraryKeys()
  },
  computed: {
    tableColKey() {
      return this.visibleCols.slice().sort().join('|')
    },
    filteredRows() {
      const sel = Array.isArray(this.filterBao) ? this.filterBao : []
      if (!sel.length || (sel.length === 1 && sel[0] === 'all')) return this.rows
      return this.rows.filter((row) => {
        const isBao2 = row.bao2 === true
        const isBao3 = row.bao3 === true
        const isShrink = !isBao2 && !isBao3
        if (sel.includes('bao2') && isBao2) return true
        if (sel.includes('bao3') && isBao3) return true
        if (sel.includes('shrink') && isShrink) return true
        return false
      })
    }
  },
  methods: {
    libraryRowKey(row) {
      return `${row.code || ''}|${row.firstBoardDate || ''}`
    },
    isInLibrary(row) {
      return !!this.libraryKeySet[this.libraryRowKey(row)]
    },
    async refreshLibraryKeys() {
      try {
        const res = await stockApi.fetchRecordLibrary()
        const map = {}
        const list = Array.isArray(res?.data) ? res.data : []
        list.forEach((r) => {
          if (!r?.code || !r?.firstBoardDate) return
          map[`${r.code}|${r.firstBoardDate}`] = r.id
        })
        this.libraryKeySet = map
      } catch (_) {
        /* ignore */
      }
    },
    openRecordLibrary() {
      this.recordLibraryVisible = true
    },
    onRecordLibraryDialogOpen() {
      this.loadRecordLibrary()
      this.loadGapUpLibrary()
    },
    async loadGapUpLibrary() {
      this.gapUpLibraryLoading = true
      try {
        const res = await stockApi.fetchGapUpLibrary()
        this.gapUpLibraryList = Array.isArray(res?.data) ? res.data : []
      } catch (e) {
        this.gapUpLibraryList = []
        this.$message.error(e?.message || '加载补涨库失败')
      } finally {
        this.gapUpLibraryLoading = false
      }
    },
    onRecordLibraryScoreVersionChange(version) {
      this.recordLibraryScoreVersion =
        version === 'V1' || version === 'V2' || version === 'V3' || version === 'V4' || version === 'V5'
          ? version
          : 'V5'
      this.loadRecordLibrary()
    },
    async loadRecordLibrary() {
      this.recordLibraryLoading = true
      this.recordLibraryEditingId = ''
      try {
        const res = await stockApi.fetchRecordLibrary({
          scoreVersion: this.recordLibraryScoreVersion
        })
        this.recordLibraryList = Array.isArray(res?.data) ? res.data : []
        const map = {}
        this.recordLibraryList.forEach((r) => {
          if (!r?.code || !r?.firstBoardDate) return
          map[`${r.code}|${r.firstBoardDate}`] = r.id
        })
        this.libraryKeySet = map
      } catch (e) {
        this.recordLibraryList = []
        this.$message.error(e?.message || '加载记录库失败')
      } finally {
        this.recordLibraryLoading = false
      }
    },
    startRecordLibraryEdit(row) {
      if (!row?.id) return
      this.recordLibraryList.forEach((item) => {
        if (item.id !== row.id) {
          this.$set(item, '_editFinalBoards', '')
          this.$set(item, '_editType', '')
        }
      })
      this.$set(row, '_editFinalBoards', row.finalBoards != null ? String(row.finalBoards) : '1')
      this.$set(row, '_editType', row.type || '')
      this.recordLibraryEditingId = row.id
    },
    async saveRecordLibraryEdit(row) {
      if (!row?.id || this.recordLibraryEditingId !== row.id) return
      const n = Number(row._editFinalBoards)
      if (!Number.isFinite(n) || n < 1) {
        this.$message.warning('最终连板高度须为 >=1 的数字')
        return
      }
      const type = String(row._editType || '').trim()
      if (type && type !== '龙头' && type !== '补涨') {
        this.$message.warning('类型仅支持：龙头 / 补涨')
        return
      }
      this.$set(row, '_saving', true)
      try {
        const res = await stockApi.updateRecordLibrary(row.id, {
          finalBoards: Math.floor(n),
          type
        })
        if (!res?.ok) {
          this.$message.error(res?.message || '保存失败')
          return
        }
        Object.assign(row, res.data || {})
        row._editFinalBoards = ''
        row._editType = ''
        this.recordLibraryEditingId = ''
        this.$message.success('已保存')
      } catch (e) {
        this.$message.error(e?.message || '保存失败')
      } finally {
        this.$set(row, '_saving', false)
      }
    },
    async removeRecordLibraryItem(row) {
      if (!row?.id) return
      try {
        await this.$confirm(`确认从记录库删除 ${row.name || row.code}？`, '提示', {
          type: 'warning'
        })
      } catch (_) {
        return
      }
      try {
        const res = await stockApi.deleteRecordLibrary(row.id)
        if (!res?.ok) {
          this.$message.error(res?.message || '删除失败')
          return
        }
        this.recordLibraryList = this.recordLibraryList.filter((item) => item.id !== row.id)
        if (this.recordLibraryEditingId === row.id) this.recordLibraryEditingId = ''
        const map = { ...this.libraryKeySet }
        delete map[this.libraryRowKey(row)]
        this.libraryKeySet = map
        this.$message.success('已删除')
      } catch (e) {
        this.$message.error(e?.message || '删除失败')
      }
    },
    async onToggleLibrary(row, checked) {
      if (!row?.code || !row?.firstBoardDate) return
      this.$set(row, '_libBusy', true)
      try {
        if (checked) {
          const res = await stockApi.addRecordLibrary({
            source: 'history-first-board',
            code: row.code,
            name: row.name || '',
            firstBoardDate: row.firstBoardDate,
            finalBoards: row.finalBoards,
            firstBoardPrice: row.firstBoardPrice,
            ma250: row.ma250,
            freeFloatMarketCap: row.freeFloatMarketCap,
            bao2: row.bao2,
            bao3: row.bao3,
            touchBoardNext: row.touchBoardNext,
            aboveAllMa: row.aboveAllMa,
            yearHighNear1y: row.yearHighNear1y,
            distToYearHighPct: row.distToYearHighPct,
            shortChip: row.shortChip,
            midChip: row.midChip,
            longChip: row.longChip,
            gapChipSum: row.gapChipSum,
            fullChip: row.fullChip,
            chipSlope: row.chipSlope,
            mainNetInflow0: row.mainNetInflow0 != null ? row.mainNetInflow0 : row.mainNetInflow,
            mainNetInflow1: row.mainNetInflow1,
            mainNetInflow2: row.mainNetInflow2,
            netInflowToAmount0:
              row.netInflowToAmount0 != null ? row.netInflowToAmount0 : row.netInflowToAmount,
            netInflowToAmount1: row.netInflowToAmount1,
            netInflowToAmount2: row.netInflowToAmount2,
            auctionGain2b: row.auctionGain2b,
            auctionTurnover2b: row.auctionTurnover2b,
            auctionVolumeRatio2b: row.auctionVolumeRatio2b,
            auctionKillScore2b: row.auctionKillScore2b,
            auctionGain3b: row.auctionGain3b,
            auctionTurnover3b: row.auctionTurnover3b,
            auctionVolumeRatio3b: row.auctionVolumeRatio3b,
            auctionKillScore3b: row.auctionKillScore3b
          })
          const id = res?.data?.id || res?.id
          if (res?.ok && id) {
            this.$set(this.libraryKeySet, this.libraryRowKey(row), id)
            this.$message.success(`已入记录库：${row.name || row.code}`)
          } else if (res?.id || id) {
            this.$set(this.libraryKeySet, this.libraryRowKey(row), res.id || id)
            this.$message.warning(res?.message || '已在记录库')
          } else {
            this.$message.error(res?.message || '入记录库失败')
          }
        } else {
          const id = this.libraryKeySet[this.libraryRowKey(row)]
          if (!id) return
          try {
            await this.$confirm(`确认从记录库移除 ${row.name || row.code}？`, '提示', {
              type: 'warning'
            })
          } catch (_) {
            return
          }
          const res = await stockApi.deleteRecordLibrary(id)
          if (!res?.ok) {
            this.$message.error(res?.message || '移除失败')
            return
          }
          const map = { ...this.libraryKeySet }
          delete map[this.libraryRowKey(row)]
          this.libraryKeySet = map
          this.recordLibraryList = this.recordLibraryList.filter((item) => item.id !== id)
          this.$message.success('已从记录库移除')
        }
      } catch (e) {
        const msg = e?.message || e?.data?.message || ''
        const id = e?.data?.id || e?.id
        if (id && checked) {
          this.$set(this.libraryKeySet, this.libraryRowKey(row), id)
          this.$message.warning(msg || '已在记录库')
        } else {
          this.$message.error(msg || (checked ? '入记录库失败' : '移除失败'))
        }
      } finally {
        this.$set(row, '_libBusy', false)
      }
    },
    isCol(key) {
      return this.visibleCols.includes(key)
    },
    onFilterBaoChange(vals) {
      const list = Array.isArray(vals) ? vals : []
      if (!list.length) {
        this.filterBao = ['all']
        return
      }
      const last = list[list.length - 1]
      if (last === 'all') {
        this.filterBao = ['all']
        return
      }
      this.filterBao = list.filter((v) => v !== 'all')
    },
    fmtBaoVol(row) {
      const isBao2 = row && row.bao2 === true
      const isBao3 = row && row.bao3 === true
      if (isBao2 && isBao3) return '爆2|爆3'
      if (isBao2) return '爆2'
      if (isBao3) return '爆3'
      return '缩量'
    },
    fmtNum(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return Number(n.toFixed(2))
    },
    fmtBool(_r, _c, v) {
      if (v === true) return '是'
      if (v === false) return '否'
      return '-'
    },
    /** 元 → 亿，保留两位小数 */
    fmtYi(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return Number((n / 1e8).toFixed(2))
    },
    /** 竞价涨幅/换手/量比/绝杀分：原样数值、不加 % */
    fmtAuctionNum(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return Number(n.toFixed(2))
    },
    fmtChipPct(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${(n * 100).toFixed(2)}%`
    },
    fmtPct(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${n.toFixed(2)}%`
    },
    fmtRatio(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return n.toFixed(4)
    },
    fmtSlope(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${(n * 1000).toFixed(2)}%`
    },
    async handleQuery() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('请选择日期范围')
        return
      }
      this.loading = true
      try {
        const res = await stockApi.queryDataBacktest({
          startDate: this.dateRange[0],
          endDate: this.dateRange[1]
        })
        this.rows = withChipScoreSum(res?.data)
        this.probResults = []
        this.probFilterHint = ''
        await this.refreshLibraryKeys()
        if (!this.rows.length) {
          this.$message.info('该区间无 ≥4 板波次')
        }
      } catch (e) {
        this.$message.error(e?.message || '查询失败')
      } finally {
        this.loading = false
      }
    },
    parseCond(fieldMeta, cond) {
      if (!cond) return null
      const asPct = !!fieldMeta.asPct
      // 空串 Number('')===0，必须先判空，否则「空条件」会被当成阈值 0
      const scale = (x) => {
        if (x == null || String(x).trim() === '') return null
        const n = Number(String(x).trim())
        if (!Number.isFinite(n)) return null
        return asPct ? n / 100 : n
      }
      if (cond.op === 'range') {
        const min = scale(cond.min)
        const max = scale(cond.max)
        if (min == null && max == null) return null
        return { op: 'range', min, max }
      }
      const value = scale(cond.value)
      if (value == null) return null
      return { op: cond.op || 'lte', value }
    },
    matchCond(raw, parsed) {
      if (!parsed) return true
      const v = Number(raw)
      if (!Number.isFinite(v)) return false
      if (parsed.op === 'lte') return v <= parsed.value
      if (parsed.op === 'gte') return v >= parsed.value
      if (parsed.op === 'range') {
        const ge = parsed.min == null ? true : v >= parsed.min
        const le = parsed.max == null ? true : v <= parsed.max
        return ge && le
      }
      return false
    },
    runProbStats() {
      const active = []
      for (const f of this.probFields) {
        const parsed = this.parseCond(f, this.probForm[f.key])
        if (!parsed) continue
        active.push({ ...f, parsed })
      }
      if (!active.length) {
        this.$message.warning('请至少填写一个条件')
        return
      }

      const needBao2 = !!this.probRequireBao2
      const needBao3 = !!this.probRequireBao3
      let baseRows = this.rows
      if (needBao2 || needBao3) {
        baseRows = this.rows.filter((row) => {
          if (needBao2 && row.bao2 === true) return true
          if (needBao3 && row.bao3 === true) return true
          return false
        })
        const parts = []
        if (needBao2) parts.push('爆2')
        if (needBao3) parts.push('爆3')
        const join = needBao2 && needBao3 ? '|' : ''
        this.probFilterHint = `已按 ${parts.join(join || '')} 过滤：${baseRows.length} / ${this.rows.length} 波`
        if (!baseRows.length) {
          this.probResults = []
          this.$message.warning('过滤后无样本，请调整爆2/爆3勾选')
          return
        }
      } else {
        this.probFilterHint = ''
      }

      const results = []
      for (const f of active) {
        let sample = 0
        const hits = []
        for (const row of baseRows) {
          const v = row[f.key]
          if (v == null || !Number.isFinite(Number(v))) continue
          sample += 1
          if (this.matchCond(v, f.parsed)) hits.push(hitStockBrief(row))
        }
        results.push({
          label: `分别 · ${f.label}`,
          hit: hits.length,
          sample,
          pct: sample ? `${((hits.length / sample) * 100).toFixed(2)}%` : '-',
          hits
        })
      }
      let comboSample = 0
      const comboHits = []
      for (const row of baseRows) {
        let okFields = true
        for (const f of active) {
          const v = row[f.key]
          if (v == null || !Number.isFinite(Number(v))) {
            okFields = false
            break
          }
        }
        if (!okFields) continue
        comboSample += 1
        const allHit = active.every((f) => this.matchCond(row[f.key], f.parsed))
        if (allHit) comboHits.push(hitStockBrief(row))
      }
      results.push({
        label: '组合 · 全部 AND',
        hit: comboHits.length,
        sample: comboSample,
        pct: comboSample ? `${((comboHits.length / comboSample) * 100).toFixed(2)}%` : '-',
        hits: comboHits
      })
      this.probResults = results
    }
  }
}
</script>

<style lang="scss" scoped>
.data-backtest {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  padding: 12px 16px;
  box-sizing: border-box;
  overflow: hidden;
}
.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-shrink: 0;
}
.hint {
  color: #909399;
  font-size: 13px;
}
.table-wrap {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.result-table {
  width: 100%;
}
.col-check-group {
  display: flex;
  flex-direction: column;
  max-height: 360px;
  overflow: auto;
}
.prob-tip {
  margin: 0 0 12px;
  font-size: 12px;
  color: #909399;
}
.unit {
  margin-left: 6px;
  color: #909399;
}
</style>

<style lang="scss">
.data-backtest-record-library-dialog {
  .el-dialog__body {
    padding-top: 8px;
    overflow-x: auto;
    min-width: 0;
  }
}
</style>
